import { addBundleToBasket } from './addBundleToBasket';

export const ADD_TO_BASKET_URL = '/api/cart/addProduct';
export const TYPE_ADD_AS_BUNDLE = 'type_bundle';

export const isValidSuccessResponse = (response, type) => {
  if (type === TYPE_ADD_AS_BUNDLE) {
    return response.error === undefined;
  }
  return !!(
    response.redirectUrl &&
    response.basketConfirmationUrl
  );
};

// If we want to display error popup, we will need the error response
export const isValidErrorResponse = (response) => !!(
  response.popupHeaderLabel &&
  response.popupMessage &&
  response.buttonLabel
);

export const addToBasket = async (
  storeUrl,
  fupid,
  quantity,
  storeId,
  deliveryType,
  psaWhenBoughtWithEnabled,
  mainProductId
) => {
  let response;

  if (psaWhenBoughtWithEnabled && mainProductId) {
    try {
      response = await addBundleToBasket(storeUrl, mainProductId, fupid);
    } catch (e) {
      throw new Error('There was an error adding bundle to the basket.');
    }
  } else {
    let params = { fupid, quantity };
    if (storeId && deliveryType) {
      params = {
        ...params,
        storeId,
        deliveryType
      };
    }
    response = await fetch(ADD_TO_BASKET_URL, {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify(params)
    });
  }

  const responseJSON = await response.json();
  const type = psaWhenBoughtWithEnabled ? TYPE_ADD_AS_BUNDLE : null;
  if (isValidSuccessResponse(responseJSON, type)) {
    return responseJSON;
  }
  if (isValidErrorResponse(responseJSON)) {
    // eslint-disable-next-line no-console
    console.warn('Adding to basket failed, product is not compatible with current basket content.');
  }
  throw new Error('There was an error adding product to the basket.');
};
